import React, { useState } from "react";
import RadiologyLayout from "./RadiologyLayout";
import IpdRadiologyOrders from "./IpdRadiologyOrders";
import { C } from "../ipd-billing/constants";
import { PageHeader } from "../rule-builder/ui";

function PatientTypeTabs({ value, onChange }) {
  const tabs = [
    { id: "ALL", label: "All" },
    { id: "OPD", label: "OPD" },
    { id: "IPD", label: "IPD" },
    { id: "EMERGENCY", label: "Emergency" },
  ];
  return (
    <div
      style={{
        display: "inline-flex",
        gap: 4,
        background: "#eef1f4",
        borderRadius: 10,
        padding: 4,
        marginBottom: 20,
      }}
    >
      {tabs.map((t) => {
        const active = value === t.id;
        return (
          <button
            key={t.id}
            type="button"
            onClick={() => onChange(t.id)}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              padding: "8px 16px",
              borderRadius: 8,
              border: "none",
              cursor: "pointer",
              fontFamily: "inherit",
              fontSize: 13,
              fontWeight: 700,
              background: active ? "#fff" : "transparent",
              color: active ? C.text : C.textSub,
              boxShadow: active ? "0 1px 3px rgba(13,35,63,0.12)" : "none",
            }}
          >
            {t.label}
          </button>
        );
      })}
    </div>
  );
}

function RadiologyTest() {
  const [patientTypeTab, setPatientTypeTab] = useState("ALL");

  return (
    <RadiologyLayout>
      <div style={{ padding: "28px 32px" }}>
        <PageHeader
          title="Tests and Examinations"
          subtitle="Patient radiology orders · status tracking · report uploads"
        />

        <PatientTypeTabs value={patientTypeTab} onChange={setPatientTypeTab} />

        <IpdRadiologyOrders patientTypeFilter={patientTypeTab} />
      </div>
    </RadiologyLayout>
  );
}

export default RadiologyTest;
